



















































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import VueRouter from 'vue-router'
import GlobalMixin, { ALERT_TYPE, VIEW_MODE } from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import DatePickerComponent from '@/components/DatePickerComponent.vue'
import PdfViewComponent from '@/components/PdfViewComponent.vue'
import SendMailDialogComponent from '@/components/SendMailDialogComponent.vue'
import DatePickerDialogComponent from '@/components/DatePickerDialogComponent.vue'
import { Report, MailQueue } from '@/domain/Report'
import { User } from '@/domain/User'
import { SendMail } from '@/domain/SendMail'
import ReportsService from '@/service/ReportsService'
import NumberIssuingService from '@/service/NumberIssuingService'
import FileData from '@/domain/FileData'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
])

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    DatePickerComponent,
    PdfViewComponent,
    SendMailDialogComponent,
    DatePickerDialogComponent,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const reportsService = ReportsService.instance
      if (to.params["no"] === undefined) {
        /* 新規 */
        vm.$data.viewMode = VIEW_MODE.NEW
        if (typeof to.query["refs"] === "string") {
          const requestNo = to.query["refs"]
          reportsService.referenceNew(requestNo).then(x => vm.$data.dto = x)
        } else {
          reportsService.createNew().then(x => vm.$data.dto = x)
        }
      } else {
        /* 編集 */
        vm.$data.viewMode = VIEW_MODE.VIEW
        reportsService.edit(to.params["no"]).then(x => vm.$data.dto = x)
      }
    })
  },
})
export default class MemberReportEdit extends Mixins(GlobalMixin) {
  numberIssuingService = NumberIssuingService.instance

  dto = new Report()
  originalDto = this.dto.clone()
  sendMail = new SendMail()

  /* 作成者、承認者リスト */
  users: User[] = []
  authorityUsers: User[] = []

  postDatePickerDialog = false
  faxDatePickerDialog = false

  mounted () {
    this.usersService.findByOccupationCode(2)
      .then((x) => {
        this.users = x
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.users = []
      })
    this.usersService.findByAuthorityCode(3)
      .then((x) => {
        this.authorityUsers = x
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.authorityUsers = []
      })
  }

  /**
   * 画面を遷移する前のチェック
   */
  // eslint-disable-next-line
  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    if (!this.isView) {
      this.confirm("このページから移動しますか？入力中のデータは保存されません").then(res => {
        res === true ? next() : next(false)
      })
    } else {
      next()
    }
  }
  
  /**
   * 編集モードに切り替える
   */
  onEdit() {
    if (this.dto.isMailSended) {
      this.confirm("既にメール送信していますが、本当に編集してよろしいですか？").then(res => {
        if (res === true) {
          this.viewMode = VIEW_MODE.EDIT
        }
      })
    } else {
      this.viewMode = VIEW_MODE.EDIT
    }
    this.originalDto = this.dto.clone()
  }

  /**
   * 削除
   */
  onDelete() {
    this.confirm("本当に削除してよろしいですか？").then(res => {
      if (res === true) {
        this.showLoading()
        this.reportsService.delete(this.dto.reportNo)
          .then(() => {
            this.viewMode = VIEW_MODE.DELETED
            this.alert("削除しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("削除に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
      }
    })
  }

  /**
   * 編集取消
   */
  onReset() {
    this.confirm("本当に編集を取り消してよろしいですか？").then(res => {
      if (res === true) {
        this.dto = this.originalDto
        this.viewMode =  VIEW_MODE.VIEW
      }
    })
  }

  /**
   * 登録ボタンのクリック
   */
  onSubmit(event: Event) {
    if ((this.$refs.observer as Vue & { validate: () => boolean }).validate()) {
      if (this.viewMode === VIEW_MODE.NEW) {
        /* 登録 */
        this.numberIssuingService.next(NumberIssuingService.REPORT, this.dto.reportOn)
          .then(no => {
            this.dto.reportNo = no
            this.save()
          })
          .catch(error => {
            // eslint-disable-next-line
            console.log(error)
          })
      } else {
        /* 更新 */
        if (this.dto.isPrinted || this.dto.isMailSended) {
          this.confirm("印刷およびメール送信情報は、消去されますがよろしいですか？").then(res => {
            if (res === true) {
              this.save()
            } else {
              event.stopPropagation()
            }
          })
        } else {
          this.save()
        }
      }
    } else {
      event.stopPropagation()
    }
  }

  /**
   * メール送信ボタンのクリック
   */
  onSendMail() {
    this.reportsService.generateMailTemplate([this.dto.reportNo])
      .then(x => {
        this.sendMail = x
        this.mailSendDialog = true
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("メール送信テンプレートの取得に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * 郵送ボタンのクリック
   */
  onSendPost() {
    this.postDatePickerDialog = true
  }

  /**
   * FAX送信ボタンのクリック
   */
  onSendFax() {
    this.faxDatePickerDialog = true
  }

  /**
   * データの保存
   */
  private save() {
    this.showLoading()
    if (this.isNew) {
      this.reportsService.create(this.dto)
        .then((x) => {
          this.dto = x
          this.viewMode = VIEW_MODE.VIEW
          this.alert("保存しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
        })
    } else {
      this.reportsService.update(this.dto)
        .then((x) => {
          this.dto = x
          this.viewMode = VIEW_MODE.VIEW
          this.alert("保存しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
        })
    }
  }

  /**
   * 初期化処理
   */
  @Watch("dto")
  changeDto() {
    /* 初期化処理 */
    if (this.viewMode === VIEW_MODE.NEW) {
      /* 作成者 */
      const authorUser = this.users.find(x => x.userId === this.loginUserId)
      if (authorUser !== undefined) {
        this.dto.authorUser.userId = authorUser.userId
        this.dto.authorUser.userName = authorUser.userName
      }
    }
  }

  /**
   * 明細行を削除
   */
  deleteDetailLine(lineIndex: number) {
    this.confirm("明細行を削除してよろしいですか？").then(res => {
      if (res === true) {
        this.dto.deleteDeailLine(lineIndex)
        this.dto.inspectionNames = this.dto.details
            .map(x => x.inspectionInfo.inspectionShortName)
            .join(",")
      }
    })
  }

  /**
   * 報告者の変更
   */
  onChangeAuthor(event: User) {
    this.dto.authorUser.userId = event.userId
    this.dto.authorUser.userName = event.userName
  }

  /**
   * 一次承認者の変更
   */
  onChangePrimaryAuthorizer(event: User) {
    this.dto.primaryAuthorizerUser.userId = event.userId
    this.dto.primaryAuthorizerUser.userName = event.userName
  }

  /**
   * 二次承認者の変更
   */
  onChangeSecondaryAuthorizer(event: User) {
    this.dto.secondaryAuthorizerUser.userId = event.userId
    this.dto.secondaryAuthorizerUser.userName = event.userName
  }

  /**
   * オートコンプリートフィルター
   */
  // eslint-disable-next-line
  usersFilter(item: User, queryText: string, itemText: string) {
    return item.userName.toLowerCase().indexOf(queryText.toLowerCase()) >= 0
  }

  /**
   * 報告書ファイルの登録
   */
  onChangeReportFile(file: File | undefined) {
    if (file === undefined) {
      this.dto.reportFile = new FileData()
    } else {
      this.readFileAsync(file).then(res => {
        if (res !== undefined) {
          this.dto.reportFile = res
        }
      })
    }
  }

  /**
   * 報告書ファイルのクリック
   */
  onClickReportFile() {
    this.isView ? this.downloadReportFile() : this.deleteReportFile()
  }

  /**
   * 報告書ファイルの削除
   */
  deleteReportFile() {
    this.confirm("報告書ファイルを削除してよろしいですか？").then(res => {
      if (res === true) {
        this.dto.reportFile = new FileData()
      }
    })
  }

  /**
   * 報告書ファイルのダウンロード
   */
  downloadReportFile() {
    if (this.dto.reportFile.filename !== '') {
      this.download(this.dto.reportFile)
    }
  }

  /**
   * 添付ファイルの登録
   */
  onChangeAttachFile(files: File[] | undefined) {
    if (files !== undefined) {
      files.forEach(x => {
        this.readFileAsync(x).then(res => {
          if (res !== undefined) {
            this.dto.attachFiles.push(res)
          }
        })
      })
    }
  }

  /**
   * 添付ファイルの削除
   */
  deleteAttachFile(index: number) {
    this.confirm("添付ファイルを削除してよろしいですか？").then(res => {
      if (res === true) {
        this.dto.attachFiles.splice(index, 1)
      }
    })
  }

  /**
   * 添付ファイルのダウンロード
   */
  // eslint-disable-next-line
  downloadAttachFile(index: number) {
    if (this.dto.attachFiles[index].filename !== '') {
      this.download(this.dto.attachFiles[index])
    }
  }

  /**
   * メール送信
   */
  onSendMailed(event: SendMail) {
    this.showLoading()
    const mailQueue = new MailQueue({to: event.to, cc: event.cc, bcc: event.bcc, replyTo: event.replyTo, subject: event.subject, content: event.content, reportNos: [this.dto.reportNo]})
    this.reportsService.mailQueuePush(mailQueue)
      .then((x) => {
          this.dto.mailSendAt = x.mailSendAt
          this.alert("メール送信しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("メール送信に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * 報告書郵送
   */
  onSendPosted(event: string) {
    this.showLoading()
    this.reportsService.sendPost([this.dto.reportNo], event)
      .then(() => {
          this.dto.postSendOn = event
          this.alert("報告書郵送日を更新しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("報告書郵送日の更新に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * 報告書FAX送信
   */
  onSendFaxed(event: string) {
    this.showLoading()
    this.reportsService.sendFax([this.dto.reportNo], event)
      .then(() => {
          this.dto.postSendOn = event
          this.alert("報告書FAX送信日を更新しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("報告書FAX送信日の更新に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * 編集
   */
  private edit(reportNo: string) {
    /* 編集 */
    this.showLoading()
    this.reportsService.edit(reportNo)
      .then(x => {
        this.viewMode = VIEW_MODE.VIEW
        this.$router.push(`/member/report/edit/${x.reportNo}`)
        this.dto = x
        this.hideLoading()
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("データ取得エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }
}
